import { AWS_S3_URL } from '@/constants/constants'

export const getS3PathForFile = (fullPath: string): string => {
  try {
    const url = new URL(fullPath)
    const s3Url = AWS_S3_URL
    const s3DomainUrl = s3Url.endsWith('/') ? s3Url.slice(0, -1) : s3Url
    return s3DomainUrl + url.pathname.replace(/\/s3/, '')
  } catch {
    return ''
  }
}
